// extracted by mini-css-extract-plugin
export default {"taskList":"TaskList_taskList__9l1Ta"};